import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 

const firebaseConfig = {
  apiKey: "AIzaSyDbIJ5vrLVCspU6IaBkFjOZQCDTkx7pW7I",
  authDomain: "sancak-9435d.firebaseapp.com",
  projectId: "sancak-9435d",
  storageBucket: "sancak-9435d.firebasestorage.app",
  messagingSenderId: "842907542110",
  appId: "1:842907542110:web:a64e3027063d36d21d0acf",
  measurementId: "G-80CXEWC83Y"
};
const app = initializeApp(firebaseConfig);
getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); 